import { specialtyBaseModel } from './crud';

export * from './types';

export const useSpecialtyByIdV2 = specialtyBaseModel.fetchByIdV2();
export const useSpecialtyByIdsV2 = specialtyBaseModel.fetchByIdsV2();
export const useSpecialtyManyV2 = specialtyBaseModel.fetchManyV2();
export const useSpecialtyUpdateOneV2 = specialtyBaseModel.editV2();
export const useSpecialtyCreateOneV2 = specialtyBaseModel.createV2();
export const useSpecialtyRemoveOneV2 = specialtyBaseModel.deleteV2();
export const useSpecialtyRemoveByIdsV2 = specialtyBaseModel.deleteByIdsV2();
export const useSpecialtyCountV2 = specialtyBaseModel.countV2();
